<template>
  <div class="container">
    <div class="bannerHeight" style="height:237px;">

    <div class="banner">
    <div class="container-nav">
        <div class="mx-center">
            <div class="mx-center-title" @click="handleType='Home';selIndex=-1;"><img src="../assets/img/logo.png" alt="" > <span class="circle"></span> 帮助中心</div>

            <div class="container-head-right">
                <!-- <router-link to="/home">首页</router-link>
                <router-link to="/productManage">操作指南</router-link> -->
                <a @click="handleType='Home';selIndex=-1;" :class="[{'router-link-map-active':handleType=='Home'}]">首页</a>
                <a href="https://w.maytek.cn/#/news?up=1" target="_blank">更新日志</a>
                <a href="http://w.maytek.cn/#/register" target="_blank">申请试用</a>
                <a href="http://w.maytek.cn/" target="_blank">美匣云官网</a>
                <a href="https://cloud.maytek.cn/" target="_blank">登录</a>
            </div>
        </div>
    </div>
    <div class="container-search">
        <div class="mx-center" >
            <div>
                <div class="container-search-title">
                    旅行社全能助手
                </div>
                <div class="search-guding" style="position:relative;">
                <div class="container-search-box">
                    <el-input v-model="value" class="search-input" style="width:520px;" placeholder="输入您要搜索问题的关键字" clearable @input="remoteMethod" ></el-input>
                    <el-button type="primary" @click="remoteMethod(value)">搜索</el-button>
                    <!-- 搜索面板 -->
                    <div class="container-search-plan" v-if="value && handleShow">
                        <div v-if="searchList.length">
                            <div class="container-search-plan-item" v-for="(item) in searchList" :key="item.helpActicleType">
                                <div>{{item.helpActicleTypeNameCn}}</div>
                                <div>
                                    <ul>
                                        <li v-for="item1 in item.content" :key="item1.numberCode" @click="searchInfo(item1,item.helpActicleType)">{{item1.nameCn}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-else class="not-data">
                            暂无数据
                        </div>
                        
                    </div>
                </div>  
                </div>
            </div>   
        </div>
    </div>
    </div>
    </div>
    <div class="container-box mx-center" >
        <div class="leftHeightFixed" style="min-height: calc(100vh - 90px);">
        <div class="leftHeight"> 
            <div class="left-nav" style="display:flex;justify-content:space-between;">
            <!-- 换接口数据 -->
            <div>
                <a  v-for="(item,index) in sortList" :key="item.numberCode"  @click="getIndex(index)">
                    <div :class="['ahover',{'router-link-active':selIndex==index}]">
                        <i :class="'iconfont '+item.icon" class="iconClass"> </i>
                        <span :style="item.icon?'position:relative;left:13px':'position:relative;left:33px'">{{item.nameCn}}</span>
                    </div>
                </a>
            </div>
            <div style="padding:18px 0 20px 0;margin-left:20px">
                <span style="width:1px;background-color:#e4e7ed;color:#fff;margin-right:50px;height:100%;display:block;"></span>
            </div>
            
            </div>
       
        </div>
        </div>
        <div class="right-content" >
            <!-- <router-view></router-view> -->
            <!-- 列表 -->
            <ProductManage  v-if="handleType == 'ProductManage'" :sonMsg="sonMsg" v-loading="loading" ></ProductManage>
            <!-- 首页 -->
            <Home  v-if="handleType == 'Home'" :listContent="meunList" ></Home>
            <!-- 详情页 -->
            <Detail  v-if="handleType == 'Detail'" :sonMsg="sonMsg" :preNext="preNext" @changeprop="changeprop" :listIdx="listIdx"></Detail>
        </div>
    </div>
    <div class="container-footer">
        <p>沪ICP备16025219号-1 上海美匣网络科技有限公司</p>
    </div>
  </div>
</template>

<script>

// import defaultApi from '@/api/api.js'
import {getHelpActicleListForPc,getHelpActicleByNumberCodeForPc,getHelpActicleTypeListForPc} from '@/api/api.js'
import ProductManage from '@/pages/productManage.vue'
import Home from '@/pages/home.vue'
import Detail from '@/pages/detail.vue'
export default {
  name: 'layout',
  components:{
      ProductManage,
      Detail,
      Home
  },
  data() {
      return {
          loading:false,
          handleShow:false,
          value:'',//搜索值
          options:[],
          meunList:[],//当前数据
          searchList:[],//搜索列表
          sonMsg:[],//传递给子组件的数据
          selIndex:-1,//当前选中项下标
          handleType:'Home',//当前操作类型值 home【首页】、ProductManage【产品列表】、detaile【详情页】
          sortList:[],//左边搜索排序列表
          preNext:[],//上一条下一条
          listIdx:'',//接收productManageindex
      }
  },
  methods:{
      handleMap(){ //操作指南对应left-nav
          this.sortList.forEach((item,index) =>{
              if(item.nameCn == this.meunList[0].helpActicleTypeNameCn){
                  this.selIndex = index
              }
          })
      },
    //   改变子组件值
      changeprop(idx){
        this.sonMsg = this.preNext[idx]
      },
      searchInfo(itemData,helpActicleType){ //跳转到订单详情
          this.meunList.forEach((item,index)=>{
              if(item.helpActicleType == helpActicleType){
                  this.goDetailInfo(itemData,index)
                //   this.value = itemData.nameCn
                  this.handleShow = false
                  this.value = ''
              }
          })
      },
      goDetailInfo(item,index){
          this.handleType = 'Detail' 
          this.sonMsg = item
          if(index != undefined){  //右边home数据与左侧边栏数据对应
              this.sortList.forEach((preitem,idx) =>{
                if(preitem.nameCn == item.helpActicleTypeNameCn){
                        this.selIndex = idx
                        this.preNext = this.meunList[index].content //点击home数据显示上下条
                        this.preNext.forEach((item1,ind) =>{ //从home进入detail显示上下条
                            if(item1.nameCn == item.nameCn){
                                this.listIdx = ind
                            }
                        })
                }
              })
           }
  
      },
     async getIndex(index){ //选择nav项
        //左边排序列表请求右边数据展示
        this.loading = true;
        const {content} = await getHelpActicleListForPc({
            type:this.sortList[index].numberCode
        })
        this.preNext = content.rows
        this.sonMsg = {
            helpActicleTypeNameCn:this.sortList[index].nameCn,
            content:content.rows
        }
        this.loading = false;
        this.selIndex = index
        this.handleType = 'ProductManage' 
      },
     async getHelpActicleByNumberCode(){
        const {content} = await getHelpActicleByNumberCodeForPc({
            numberCode:this.$route.query.id
        })
        this.searchInfo(content,content.helpActicleType)
     },
    //  左边排序列表
     async getHelpActicleTypeListForPc(){
        const {content} = await getHelpActicleTypeListForPc({
            
        })
        this.sortList=content
     },
     
     async getListData(val){ //获取列表数据
        const {content} = await getHelpActicleListForPc({
             type:val
        })
        this.preNext = content.rows
     },
      async getData(val){ //获取初始数据
        const {content} = await getHelpActicleListForPc({
            queryStr:val?val:'',
        })
      
       
          let newArr = []
          // 筛选数据   
          if(content.rows.length){
            content.rows.forEach(item => {
                if(newArr.length){
                    let arr = newArr.map(item=>item.helpActicleType)
                    if(arr.includes(item.helpActicleType)){
                        newArr.forEach(item2=>{
                            if(item2.helpActicleType == item.helpActicleType){
                                item2.content.push(item)
                            }
                        })
                    }else{
                        newArr.push({
                            helpActicleType:item.helpActicleType,
                            helpActicleTypeNameCn:item.helpActicleTypeNameCn,
                            browseNum:item.browseNum,
                            content:[item]
                        })
                    }
                    
                }else{//首次直接压入
                    newArr.push({
                        helpActicleType:item.helpActicleType,
                        helpActicleTypeNameCn:item.helpActicleTypeNameCn,
                        browseNum:item.browseNum,
                        content:[item]
                    })

                }
            });
            
          }
        if(this.$route.query.id&&!val){
            this.getHelpActicleByNumberCode()
            
        }
        
        if(val){
            this.searchList = newArr
        }else{
            this.meunList = newArr
            this.sonMsg = this.meunList[0]
        }     
          
      },
      remoteMethod(val){ //远程搜索
          
          if(val){
              this.getData(val)
          }
          
      },
      scrollToTop() {
        // let that = this;
        // let $winHeight = document.body.clientHeight; // 窗口可视区域的高度

        let $winScrollHeight = document.documentElement.scrollTop || document.body.scrollTop; // 浏览器滚动的距离
       
        if($winScrollHeight>120){
            this.$el.querySelectorAll(".container-search-box")[0].classList.add("container-search-box-fixed");
        }else{
            this.$el.querySelectorAll(".container-search-box")[0].classList.remove("container-search-box-fixed");
            
        }//搜索框头部固定
        if($winScrollHeight>180){
            this.$el.querySelectorAll(".banner")[0].classList.add("banner-fixed");
            this.$el.querySelectorAll(".leftHeight")[0].classList.add("sticky");
            this.$el.querySelectorAll(".right-content")[0].classList.add("sticky-content");
        }else {
            this.$el.querySelectorAll(".banner")[0].classList.remove("banner-fixed");
            this.$el.querySelectorAll(".leftHeight")[0].classList.remove("sticky");
            this.$el.querySelectorAll(".right-content")[0].classList.remove("sticky-content");
        }//背景图片+左边导航+右边内容  固定

        let $sl = document.body.scrollLeft || document.documentElement.scrollLeft;
        
        if($sl > (document.documentElement.clientLeft)){
            if($sl != 0){
                let lr = -Math.max(document.body.scrollLeft,document.documentElement.scrollLeft);
                this.$el.querySelectorAll('.leftHeight')[0].style.left = lr + 'px';
            }
        }else{
            this.$el.querySelectorAll('.leftHeight')[0].style.left = 'inherit';
        }//出现横向滚动条时，左边导航条一起滚动
      


    },
   
  },
  mounted() {
      window.addEventListener("scroll", this.scrollToTop);
      let that = this
      document.getElementsByTagName('html')[0].addEventListener("click", function(){
          that.handleShow = false
          that.value = ''
      });
      document.getElementsByClassName('search-input')[0].addEventListener("click", function(e){
          window.event? window.event.cancelBubble = true : e.stopPropagation();
          that.handleShow = true
      });
      this.getData()
      
      this.getHelpActicleTypeListForPc()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.banner-fixed{
    position: fixed;
    top: -180px;
    z-index: 322;
}
.container-search-box-fixed{
    position: fixed;
    top: 10px;
    left: 50%;
    z-index: 444;
    margin-left: -410px;
}
.sticky{
    position:fixed;
    top: 41px;
    z-index: 321;
    width: 240px;
    height: auto !important;
    padding-top: 16px;
    background-color: #FAFAFB;
}
.sticky-content{
    margin-left: 230px;
}
.search-box{
    position:fixed;
    top: 40px;
    left:660px;
    z-index: 333;
}
.search-box-input{
    background-color:#000 !important;
    color:#fff;
}
/deep/ .el-input__inner{
    border-radius: 0px !important;
    height:36px;
    line-height:36px;
    font-size: 12px;
    border:none;
}



.mx-center{
    width: 1300px !important;
}
.mx-center-title{
    font-size: 20px;
    font-weight:700;
    color: #fff;
    display: flex;
    align-items: center;
    cursor: pointer;
}
    .container{
        .container-head{
            background:#1b1436;
            height: 30px;
            color: #fff;
            line-height: 30px;
            font-size:14px;
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 333;
            &>div{
                display:flex;
                justify-content:flex-end;
                align-items: center;
                .container-head-right{
                    a{
                        text-decoration: none;
                        cursor: pointer;
                        color: #e3e3e3;
                    }
                    &>a:nth-child(1),&>a:nth-child(2){
                        margin-right:50px;
                    }
                   
                }
            }
            
        }
       .banner{
           background:url('../assets/img/banner.png') no-repeat center;
           height: 237px;
           min-width: 1300px;
           width: 100%;
           background-size: cover;
       }
        .container-nav{
            font-size:14px;
            position: fixed;
            width: 100%;
            z-index: 333;
            height:50px;
            top: 0;
            display: flex;
            align-items: center;
            .circle{
                display:inline-block;width:6px;height:6px;background:#fff;
                border-radius: 50%;
                margin: 0 10px;
            }
             &>div{
                display:flex;
                justify-content:space-between;
                align-items: center;
                .container-head-right{
                    a{
                        text-decoration: none;
                        cursor: pointer;
                        color: #ccc;
                        margin-right:44px;
                    }
                    &>a:last-child{
                        margin-right:0;
                    }
                    &>span:nth-child(1){
                        margin-right:20px;
                    }
                }
            }
        }
        .container-search{
           padding: 20px ;
            height:138px;
            position: relative;
            color: #fff;
            margin-bottom: 10px;
            top: 60px;
            transition: all .2s;
            width: calc(100% - 40px);
            min-width: 1200px;
           

           .mx-center{
               position:absolute;
               top: 50%;
               left: 50%;
               margin-left: -653px;
               margin-top: -50px;
               display: flex;
               justify-content: center;
               &>div{
                   display:inline-block;
                   position: relative;
                   padding-bottom: 10px;
                   .container-search-title{
                       font-size: 24px;
                       letter-spacing: 5px;
                       margin-bottom: 20px;
                       font-weight: 200;
                       text-align: center;
                   }
                   .container-search-box{
                       .el-button{
                            background:#4646fd;
                            width: 80px;
                            border-radius: 0;
                            border: none;
                            height: 36px !important;
                            position: relative;
                            top: 2px;
                        }
                   }
                   
                   .container-search-plan{
                       width:518px;
                        border: 1px solid #eee;
                        background:#fff;
                       position:absolute;
                       top:48px;
                       left: 0;
                       z-index:333;
                       color: #333;
                       max-height: 400px;
                       overflow:auto;
                       .not-data{
                           padding:20px;
                           color:#999;
                       }
                       .container-search-plan-item{
                           display: flex;
                           div:first-child{
                               flex: 0 0 120px;
                               background:#FFFFFF;
                               text-align: left;
                               padding:8px 8px 8px 10px;
                               font-size:12px;
                               color: #999;
                               overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                           }
                           div:last-child{
                               flex:1;
                               ul{
                                   li{
                                       padding:8px 8px 8px 2px;
                                       line-height: 24px;
                                       text-align: left;
                                       overflow: hidden;
                                       text-overflow: ellipsis;
                                       white-space: nowrap;
                                       cursor: pointer;
                                       font-size: 14px;
                                       &:hover{
                                            color: #4646fd;
                                        }
                                         
                                   }
                                   border-bottom: 1px solid #eee;
                                       
                               }
                           }
                           
                            &:last-child{
                                ul{
                                    border-bottom: none  !important;
                                }   
                            }
                       }
                   }
                   &:hover{
                       .container-search-plan{
                           display:block;
                       }
                   }
               }
           }
        }
        .el-button{
            background:#4646fd;
            width: 80px;
            border-radius: 0;
            border: none;
            height: 38px;
            position: relative;
            top: 1px;
        }
        
        .container-box{
            display: flex;
            min-height: calc(100vh - 313px);
            .leftHeight{
                width: 230px;
            }
            .left-nav{
                flex:0 0 240px;
                font-size: 14px;
                margin-right: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
                min-height: auto;
                a{
                    width: calc(100% - 0px);
                    display: block;
                    padding: 10px;
                    text-align: left;
                    .iconClass{
                        font-size:20px;
                        vertical-align: middle;
                        margin-left:10px;
                        background-image: linear-gradient(0deg, #d10a24 0%, #1b3ce3 100%);
                        -webkit-background-clip: text;
                        color: transparent;
                    }
                   
                }
            }
            .right-content{
                flex: 1;
                min-height: calc(100vh - 480px);
                overflow: auto;
                margin-top: 16px;
            }

        }
        .container-footer{
            color: #ccc;
            margin: 10px auto 10px;
            text-align: center;
        }
    }
    

    .router-link-active{
        color: #fff !important;
        background-color: #5b75ed !important;
        border-radius: 6px;
        .iconClass{
            background-image: none !important;
            color: #fff !important;
        }
    }
    .router-link-map-active{
        color: #fff !important;
    }
    a{
        text-decoration: none;
        color: #333;
        .ahover{
            width: 138px;
            height: 32px;
            line-height: 32px;
        }
        .ahover:hover{
            background-color: #eaecfa;
            border-radius: 6px;
            
        }
    }
</style>
